export default __webpack_public_path__ + "static/media/mpn-logotype-l.51c3f294.svg";